import React, { useContext, useState, useCallback, useMemo, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Pergunta } from 'api/Assessor/duvidas';
import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';
import Conversa from './Conversa';
import Filtro from './Filtro';
import useStyle from './style';

export type FilterType = 'respondido' | 'pendente';

interface Totais extends Record<string, number> {
  respondido: number;
  pendente: number;
}

export default function () {
  const classes = useStyle();
  const { conversas, irParaConversa, termoPesquisa } = useContext(MensagensContext);
  const [filterBy, setFilter] = useState<FilterType>();

  const filtrarRespondido = useCallback(() => {
    return conversas.filter(conversa => conversa.perguntas.some(pergunta => pergunta.resposta !== null));
  }, [conversas]);

  const filtrarPendente = useCallback(() => {
    return conversas.filter(conversa => conversa.perguntas.some(pergunta => !pergunta.resposta));
  }, [conversas]);

  const filtrarTermo = useCallback(() => {
    return conversas.filter(
      conversa =>
        conversa.nome.toLowerCase().includes(termoPesquisa!.toLowerCase()) ||
        conversa.cpfUsuario.includes(termoPesquisa!)
    );
  }, [termoPesquisa, conversas]);

  const countCurrentTotais = (conversa: Array<Pergunta>): Totais => {
    return conversa.reduce(
      (total, current) => {
        if (current.resposta) {
          return { ...total, respondido: total.respondido + 1 };
        }
        return { ...total, pendente: total.pendente + 1 };
      },
      { respondido: 0, pendente: 0 }
    );
  };

  const countTotais = useMemo(() => {
    return conversas.reduce(
      (total: Totais, currentLista) => {
        if(currentLista.nome !== "ADMINISTRADOR DA ASSEMBLEIA"){
          const current = countCurrentTotais(currentLista.perguntas);
          return {
            respondido: total.respondido + current.respondido,
            pendente: total.pendente + current.pendente,
          };
        }
        return {
          respondido: total.respondido,
          pendente: total.pendente,
        };
      },
      { respondido: 0, pendente: 0 }
    );
  }, [conversas]);

  const filtrado = useMemo(() => {
    if (termoPesquisa && termoPesquisa.length > 0) return filtrarTermo();
    if (filterBy === 'pendente') return filtrarPendente();
    if (filterBy === 'respondido') return filtrarRespondido();
    return conversas;
  }, [filterBy, conversas, filtrarPendente, filtrarRespondido, termoPesquisa, filtrarTermo]);

  const onChangeFilter = useCallback(
    (value: FilterType | undefined) => {
      setFilter(value);
      irParaConversa('');
    },
    [irParaConversa]
  );

  useEffect(() => {
    if (termoPesquisa && termoPesquisa.length > 0) {
      irParaConversa('');
    }
  }, [termoPesquisa, irParaConversa]);

  return (
    <Grid item component="nav" className={classes.root}>
      {(!termoPesquisa || termoPesquisa.length === 0) && (
        <Filtro respondidos={countTotais.respondido} pendentes={countTotais.pendente} onChange={onChangeFilter} />
      )}
      {filtrado.map(usuario => (
        <Conversa key={usuario.cpfUsuario} {...usuario} />
      ))}
    </Grid>
  );
}
